(function() {
    function shippable_auto_complete_addressToString(address) {
        return address.street + ' ' + address.number + ', ' + ' ' + address.town + ' ' + address.zip;
    }


    function shippable_auto_complete_setAddress($container, address) {
        let street = address, town = null, number = null, zip = null, realTown = null;
        if (address !== undefined && address != null) {
            street = address.hasOwnProperty('street') ? address.street : address;
            town = address.town;
            realTown = address.realTown;
            number = address.number;
            zip = address.zip;
        }
        $container.find('input.street').val(street);
        $container.find('input.town').val(town);
        $container.find('input.realTown').val(realTown);
        $container.find('input.number').val(number);
        $container.find('input.zip').val(zip);
    }

    function isInitialized($el) {
        return $el.data('shippableAutoComplete') !== undefined;
    }

    function geoEquals(g1, g2) {
        return g1 !== null
            && g2 !== null
            && g1.longitude === g2.longitude
            && g1.latitude === g2.latitude;
    }

    function init() {
        const element = $(this);
        const form = element.parents('form')[0];
        form.preSubmit = function(e) {
            let autocomplete = $(this).find('.shippable-autocomplete');
            if (autocomplete.length && !autocomplete.dropdown('get value')) {
                let selectedItem = autocomplete.find('.item.selected');
                if (selectedItem.length) {
                    e.preventDefault();
                    autocomplete.find('input.search').val('');
                    autocomplete.dropdown('set selected', selectedItem.data('value'));
                }
            }
        };
        form.preSubmit = form.preSubmit.bind(form);
        $(form).submit(form.preSubmit);
        form.onXhrResponse = function(response) {
            if (response) {
                if (!response.result && response.form_errors) {
                    for (let form_name in response.form_errors) {
                        let errorsContainer = $('[data-form-errors="' + form_name + '"]');
                        if (errorsContainer.length) {
                            errorsContainer.html(response.form_errors[form_name]);
                            $(this).registerValidationErrors(errorsContainer.find('.sylius-validation-error'));
                        }
                    }
                }
                if (response.result && response.html) {
                    $('[data-form-errors="' + this.name + '"]').html(response.html);
                    setTimeout(function() {
                        let backLink = $('.back-to-messenger-link');
                        backLink.transition('tada');
                        setInterval(function() {
                            backLink.transition('tada');
                        }, 5000);
                    }, 250);
                }
                $(this).removeClass('loading');
            }
        };
        form.onXhrResponse = form.onXhrResponse.bind(form);
        if (isInitialized(element)) {
            throw new Error('shippableAutoComplete is already initialized');
        }

        const searchUrl = element.data('search-url');
        const geoUrl = element.data('geo-url');

        const $parent = element.parents('form');
        const $menuElement = element.find('div.menu');
        const $inputSearch = element.find('input.search');
        const self = this;
        let formSubmitted = false;

        $inputSearch.on('input', function() {
            if ($inputSearch.val().length === 0) {
                $menuElement.find('div.item').remove();
            }
        });

        const apiSettings = {
            dataType: 'JSON',
            silent: true,
            cache: false,
            onRequest: (function() {
                /**
                 * This shouldn't be necessary as it is functionality of the api already but it somehow doesn't work.
                 *
                 * Problem can be seen when opening the page with address, start moving the map and inspecting
                 * network requests. Most of them won't be canceled (all of them except last one should be).
                 */
                let prevXhr = null;
                return function(promise, xhr) {
                    if (prevXhr) {
                        prevXhr.abort();
                    }
                    prevXhr = xhr;
                };
            })(),
            beforeSend: (function() {
                let lastSearchedGeo = null;
                return function (settings) {
                    const options = element.data('shippableAutoComplete');
                    switch (options.mode) {
                        case 'search':
                            const query = settings.urlData.query || '';
                            if (query.length < 1) {
                                return false;
                            }

                            settings.url = searchUrl;
                            settings.data = {q: query};
                            lastSearchedGeo = null;
                            break;
                        case 'geo':
                            settings.url = geoUrl;
                            settings.data = options.geo;
                            if (geoEquals(lastSearchedGeo, options.geo)) {
                                setMode.call(self, 'search');
                                return false;
                            }
                            lastSearchedGeo = options.geo;
                            break;
                    }

                    return settings;
                };
            })(),
            onResponse: function (response) {
                const myResults = [];
                const addressById = {};
                $.each(response, function (index, item) {
                    addressById[item.id] = item;

                    myResults.push({
                        name: shippable_auto_complete_addressToString(item),
                        value: item.id
                    });
                });
                element.data('address-by-id', addressById);

                // select nearest address user pointed to on the map
                const options = element.data('shippableAutoComplete');
                if (myResults.length !== 0 && options.mode === 'geo') {
                    setTimeout(function() {
                        setTimeout(function() {
                            const $item = element.dropdown('get item', myResults[0].value);
                            if ($item !== false) {
                                element.dropdown('set selected item', $item);
                            }
                        }, 0);
                    }, 0);
                }

                if (options.mode === 'geo') {
                    setMode.call(self, 'search');
                }

                return {success: true, results: myResults};
            }
        };

        element.dropdown({
            clearable: true,
            delay: {
                search: 250
            },
            selectOnKeydown: false,
            allowTab: false,
            minCharacters: 0,
            allowAdditions: true,
            forceSelection: false,
            onChange: function (value, text) {
                $(this).parents('form').find('.sylius-validation-error').each(function() {
                    $(this).remove();
                });
                if (value === '') {
                    shippable_auto_complete_setAddress($parent, null);
                } else {
                    const addressById = element.data('address-by-id');
                    const address = Number.isInteger(Number(value))
                        ? addressById[value]
                        : text;

                    shippable_auto_complete_setAddress($parent, address);

                    if (element.data('submit-on-change')) {
                        formSubmitted = true;
                        element.closest('form')
                            .addClass('loading')
                            .submit();
                    }
                }
            },
            apiSettings: apiSettings
        });

        element.data(
            'shippableAutoComplete',
            {
                mode: 'search'
            }
        );

        element.click(function(e) {

            let currentValue = element.dropdown('get value');
            let clickedValue = $(e.target).data('value');
            // when user selects the same address, the form needs to resubmit
            if (!formSubmitted && clickedValue && clickedValue == currentValue) {
                element.dropdown('remove selected', currentValue);
                element.dropdown('set selected', currentValue); // triggering onChange on dropdown widget
            }
        });
    }

    /**
     * @param {'search'|'geo'} mode
     */
    function setMode(mode) {
        const $el = $(this);
        const settings = $el.data('shippableAutoComplete');

        if (settings.mode === mode) {
            return;
        }

        settings.mode = mode;
        $el.dropdown('search');
    }

    /**
     * @param {{longitude: number, latitude: number}} geo
     */
    function setGeo(geo) {
        const $el = $(this);
        const settings = $el.data('shippableAutoComplete');
        settings.geo = geo;

        if (settings.mode === 'geo') {
            $el.dropdown('search');
        } else {
            setMode.call(this, 'geo');
        }
    }

    const methods = {
        init: init,
        mode: setMode,
        geo: setGeo
    };

    $.fn.extend({
        shippableAutoComplete: function () {
            const method = arguments[0] || 'init';
            const methodArguments = [].slice.call(arguments, 1);
            const fn = methods[method];
            if (!fn) {
                throw new Error('Method "' + method + '" does not exists')
            }

            return this.each(function () {
                fn.apply(this, methodArguments);
            });
        }
    });
})();